import { render } from "./SaveDialog.vue?vue&type=template&id=3b090208"
import script from "./SaveDialog.vue?vue&type=script&lang=js"
export * from "./SaveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__